module.exports = __webpack_public_path__ + "img/bathroom03.c0458e6e.jpg";